interface RedirectLocationLike {
  pathname?: string;
  search?: string;
  hash?: string;
}

function sanitizeRedirectTarget(target: string | null | undefined): string {
  if (!target) return '/';

  const normalized = target.trim();
  if (!normalized.startsWith('/')) return '/';
  if (normalized.startsWith('//')) return '/';
  if (/^\/login(?:[/?#]|$)/.test(normalized)) return '/';

  return normalized || '/';
}

export function buildRedirectTarget(location: RedirectLocationLike): string {
  const pathname = location.pathname || '/';
  const search = location.search || '';
  const hash = location.hash || '';
  return sanitizeRedirectTarget(`${pathname}${search}${hash}`);
}

export function buildLoginRedirectPath(location: RedirectLocationLike): string {
  const redirectTarget = buildRedirectTarget(location);
  if (redirectTarget === '/') return '/login';

  const params = new URLSearchParams();
  params.set('redirect', redirectTarget);
  return `/login?${params.toString()}`;
}

export function resolvePostLoginRedirect(search: string): string {
  const params = new URLSearchParams(search);
  return sanitizeRedirectTarget(params.get('redirect'));
}
